module.exports = __webpack_public_path__ + "media/Images/woman-with-book-6a8f8699596ba78234a25b5d96bcf2de.jpg";